import { useState } from 'react';

import Flex from 'quarks/Flex';
import Heading from 'quarks/Heading';

import CompanyNewsCard from 'components/Author/CompanyNewsCard';
import PostCard from 'components/Author/PostCard';
import ComponentButton from 'components/Button/ComponentButton';

import type { ContentfulTemplateBlogPost, ContentfulTemplateCompanyNews, ContentfulTemplateVideo } from 'graphqlTypes';
import type { FC } from 'react';

interface AuthorPostsProps {
  posts: (ContentfulTemplateBlogPost | ContentfulTemplateCompanyNews | ContentfulTemplateVideo)[];
}

const AuthorPosts: FC<AuthorPostsProps> = ({ posts }) => {
  const [postsDisplayed, setPostsDisplayed] = useState(6);

  const handleLoadMore = () => setPostsDisplayed(prevState => prevState + 6);

  const renderCard = (post: ContentfulTemplateBlogPost | ContentfulTemplateCompanyNews | ContentfulTemplateVideo) => {
    switch (post.__typename) {
      case 'ContentfulTemplateBlogPost' || 'ContentfulTemplateVideo':
        return <PostCard key={post.id} {...post} />;
      case 'ContentfulTemplateCompanyNews':
        return <CompanyNewsCard key={post.id} {...post} />;
      default:
        return '';
    }
  };

  return (
    <Flex flexDirection="column" gap="40px" md={{ gap: '48px' }} lg={{ gap: '64px' }}>
      <Heading
        as="h2"
        borderBottom="4px solid"
        borderColor="gray-900"
        textStyle="sm"
        paddingBottom={8}
        md={{ textStyle: 'md' }}
      >
        Recent Posts
      </Heading>
      <Flex flexDirection="column" gap="48px" md={{ gap: '56px' }} lg={{ gap: '64px' }}>
        {posts.slice(0, postsDisplayed).map(post => renderCard(post))}
      </Flex>
      {posts.length > postsDisplayed && (
        <Flex justifyContent="center">
          <ComponentButton hierarchy="Secondary Dark" onClick={handleLoadMore} label="Load More" />
        </Flex>
      )}
    </Flex>
  );
};

export default AuthorPosts;
